import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Card,
  Spin,
  Row,
  Col,
  Tag,
  Typography,
  message,
  Empty,
  Table,
  Button,
  Select,
  Modal,
  Space,
  Alert,
} from "antd";
import {
  ReloadOutlined,
  SendOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import MotionHoc from "../../../utils/MotionHoc";
import {
  GET_AMC_SELL,
  GET_AMC_STOCK,
  GET_AMC_STOCK_SELL,
  GET_AMC_STOCK_TAX,
  GET_NPL_CLOSE_OLD_CONTNO,
  GET_NPL_MOVE_IN_OLD_STOCK_CAR,
  GET_NPL_RECEIVE_PAYMENT,
  GET_NPL_REPORT,
  GET_NPL_SELL_AGREEMENT,
  GET_NPL_SELL_JUDGE,
  GET_PENDING_SALE_CAR_IMPOUND,
  GET_SELLING_CAR_IMPOUND,
  HEADERS_NPL,
  POST_AMC_SELL_ALL,
  POST_AMC_SELL_SELECT,
  POST_AMC_STOCK_ALL,
  POST_AMC_STOCK_SELECT,
  POST_AMC_STOCK_SELL_ALL,
  POST_AMC_STOCK_SELL_SELECT,
  POST_AMC_STOCK_TAX_ALL,
  POST_AMC_STOCK_TAX_SELECT,
  POST_NPL_CLOSE_OLD_CONTNO,
  POST_NPL_MOVE_IN_OLD_STOCK_CAR,
  POST_NPL_MOVE_IN_OLD_STOCK_CAR_SELECT,
  POST_NPL_RECEIVE_PAYMENT,
  POST_NPL_RECEIVE_PAYMENT_SELECT,
  POST_NPL_SELL_AGREEMENT,
  POST_NPL_SELL_AGREEMENT_SELECT,
  POST_NPL_SELL_JUDGE,
  POST_NPL_SELL_JUDGE_SELECT,
  POST_PENDING_SALE_CAR_IMPOUND,
  POST_PENDING_SALE_CAR_IMPOUND_SELECT,
  POST_SELLING_CAR_IMPOUND,
  POST_SELLING_CAR_IMPOUND_SELECT,
  GET_HOUSING_DEPOSIT,
  POST_HOUSING_DEPOSIT_ALL,
  POST_HOUSING_DEPOSIT_SELECT,
  GET_HOUSING_DEPOSIT_TAX,
  POST_HOUSING_DEPOSIT_TAX_ALL,
  POST_HOUSING_DEPOSIT_TAX_SELECT,
  GET_HOUSING_SELL,
  GET_HOUSING_SELL_TAX,
  POST_HOUSING_SELL_ALL,
  POST_HOUSING_SELL_SELECT,
  POST_HOUSING_SELL_TAX_ALL,
  POST_HOUSING_SELL_TAX_SELECT,
  GET_HOUSING_RECV,
  GET_HOUSING_RECV_TAX,
  POST_HOUSING_RECV_ALL,
  POST_HOUSING_RECV_SELECT,
  POST_HOUSING_RECV_TAX_ALL,
  POST_HOUSING_RECV_TAX_SELECT,
  GET_AMC_DEPOSIT,
  POST_AMC_DEPOSIT_ALL,
  POST_AMC_DEPOSIT_SELECT,
  GET_AMC_DEPOSIT_TAX,
  POST_AMC_DEPOSIT_TAX_ALL,
  POST_AMC_DEPOSIT_TAX_SELECT,
  GET_TO_HOUSING,
  POST_TO_HOUSING_ALL,
  GET_TO_HOUSING_TAX,
  POST_TO_HOUSING_TAX_ALL,
  POST_TO_HOUSING_TAX_SELECT,
  POST_TO_HOUSING_SELECT,
  GET_AMC_TAX,
  POST_AMC_TAX_ALL,
  POST_AMC_TAX_SELECT,
  GET_HOUSING_LEASE_REFUND,
  POST_HOUSING_LEASE_REFUND_ALL,
  POST_HOUSING_LEASE_REFUND_SELECT,
  GET_HOUSING_LEASE_REFUND_TAX,
  POST_HOUSING_LEASE_REFUND_TAX_ALL,
  POST_HOUSING_LEASE_REFUND_TAX_SELECT,
  GET_HOUSING_LEASE_CLOSE,
  POST_HOUSING_LEASE_CLOSE_ALL,
  POST_HOUSING_LEASE_CLOSE_SELECT,
  GET_HOUSING_LEASE_CLOSE_TAX,
  POST_HOUSING_LEASE_CLOSE_TAX_ALL,
  POST_HOUSING_LEASE_CLOSE_TAX_SELECT,
  GET_HOUSING_LEASE_OTHER,
  POST_HOUSING_LEASE_OTHER_ALL,
  POST_HOUSING_LEASE_OTHER_SELECT,
  GET_HOUSING_LEASE_OTHER_TAX,
  POST_HOUSING_LEASE_OTHER_TAX_ALL,
  POST_HOUSING_LEASE_OTHER_TAX_SELECT,
} from "../../API/apiUrls";
import { OPTIONS_TYPE } from "../preInvestigateAssets/constant/SchemaType";
import DateCustom from "../../../hook/DateCustom";
import { ThaiRangePicker } from "../../../hook/ThaiDatePicker";
import dayjs from "dayjs";
import {
  blockLabel,
  blockTell,
  isToHousing,
  summarizeSync,
  shouldStopSync,
  httpErrorText,
  TONE_ALERT_TYPE,
} from "./constant/toHousing";

const { Title, Text } = Typography;

const THEME = {
  primary: "#1a365d",
  secondary: "#2d4a6f",
  accent: "#e67e22",
  success: "#27ae60",
  warning: "#f39c12",
  danger: "#e74c3c",
  info: "#3498db",
  gradient: "linear-gradient(135deg, #1a365d 0%, #2d4a6f 100%)",
  borderRadius: "12px",
};

const STATUS_API_MAP_LAWYER = {
  1: [GET_NPL_CLOSE_OLD_CONTNO, POST_NPL_CLOSE_OLD_CONTNO],
  2: [GET_NPL_SELL_JUDGE, POST_NPL_SELL_JUDGE, POST_NPL_SELL_JUDGE_SELECT],
  3: [
    GET_NPL_SELL_AGREEMENT,
    POST_NPL_SELL_AGREEMENT,
    POST_NPL_SELL_AGREEMENT_SELECT,
  ],
  4: [
    GET_NPL_MOVE_IN_OLD_STOCK_CAR,
    POST_NPL_MOVE_IN_OLD_STOCK_CAR,
    POST_NPL_MOVE_IN_OLD_STOCK_CAR_SELECT,
  ],
  6: [
    GET_NPL_RECEIVE_PAYMENT,
    POST_NPL_RECEIVE_PAYMENT,
    POST_NPL_RECEIVE_PAYMENT_SELECT,
  ],
  7: [
    GET_PENDING_SALE_CAR_IMPOUND,
    POST_PENDING_SALE_CAR_IMPOUND,
    POST_PENDING_SALE_CAR_IMPOUND_SELECT,
  ],
  8: [
    GET_SELLING_CAR_IMPOUND,
    POST_SELLING_CAR_IMPOUND,
    POST_SELLING_CAR_IMPOUND_SELECT,
  ],
};

const STATUS_API_MAP_AMC = {
  1: [GET_AMC_STOCK, POST_AMC_STOCK_ALL, POST_AMC_STOCK_SELECT],
  2: [GET_AMC_SELL, POST_AMC_SELL_ALL, POST_AMC_SELL_SELECT],
  3: [GET_AMC_STOCK_TAX, POST_AMC_STOCK_TAX_ALL, POST_AMC_STOCK_TAX_SELECT],
  4: [GET_AMC_STOCK_SELL, POST_AMC_STOCK_SELL_ALL, POST_AMC_STOCK_SELL_SELECT],
  5: [GET_AMC_DEPOSIT, POST_AMC_DEPOSIT_ALL, POST_AMC_DEPOSIT_SELECT],
  6: [
    GET_AMC_DEPOSIT_TAX,
    POST_AMC_DEPOSIT_TAX_ALL,
    POST_AMC_DEPOSIT_TAX_SELECT,
  ],
  7: [GET_TO_HOUSING, POST_TO_HOUSING_ALL, POST_TO_HOUSING_SELECT],
  8: [GET_TO_HOUSING_TAX, POST_TO_HOUSING_TAX_ALL, POST_TO_HOUSING_TAX_SELECT],
  9: [GET_AMC_TAX, POST_AMC_TAX_ALL, POST_AMC_TAX_SELECT],
};

const STATUS_API_MAP_HOUSING = {
  3: [
    GET_HOUSING_DEPOSIT,
    POST_HOUSING_DEPOSIT_ALL,
    POST_HOUSING_DEPOSIT_SELECT,
  ],
  4: [
    GET_HOUSING_DEPOSIT_TAX,
    POST_HOUSING_DEPOSIT_TAX_ALL,
    POST_HOUSING_DEPOSIT_TAX_SELECT,
  ],
  1: [GET_HOUSING_SELL, POST_HOUSING_SELL_ALL, POST_HOUSING_SELL_SELECT],
  2: [
    GET_HOUSING_SELL_TAX,
    POST_HOUSING_SELL_TAX_ALL,
    POST_HOUSING_SELL_TAX_SELECT,
  ],
  5: [GET_HOUSING_RECV, POST_HOUSING_RECV_ALL, POST_HOUSING_RECV_SELECT],
  6: [
    GET_HOUSING_RECV_TAX,
    POST_HOUSING_RECV_TAX_ALL,
    POST_HOUSING_RECV_TAX_SELECT,
  ],
  7: [
    GET_HOUSING_LEASE_REFUND,
    POST_HOUSING_LEASE_REFUND_ALL,
    POST_HOUSING_LEASE_REFUND_SELECT,
  ],
  8: [
    GET_HOUSING_LEASE_REFUND_TAX,
    POST_HOUSING_LEASE_REFUND_TAX_ALL,
    POST_HOUSING_LEASE_REFUND_TAX_SELECT,
  ],
  9: [
    GET_HOUSING_LEASE_CLOSE,
    POST_HOUSING_LEASE_CLOSE_ALL,
    POST_HOUSING_LEASE_CLOSE_SELECT,
  ],
  10: [
    GET_HOUSING_LEASE_CLOSE_TAX,
    POST_HOUSING_LEASE_CLOSE_TAX_ALL,
    POST_HOUSING_LEASE_CLOSE_TAX_SELECT,
  ],
  11: [
    GET_HOUSING_LEASE_OTHER,
    POST_HOUSING_LEASE_OTHER_ALL,
    POST_HOUSING_LEASE_OTHER_SELECT,
  ],
  12: [
    GET_HOUSING_LEASE_OTHER_TAX,
    POST_HOUSING_LEASE_OTHER_TAX_ALL,
    POST_HOUSING_LEASE_OTHER_TAX_SELECT,
  ],
};

const STATUS_OPTIONS_LAWYER = [
  { value: 1, icon: "📑", label: "Phase 1 (ปิดสัญญาเดิม)" },
  { value: 2, icon: "⚖️", label: "Phase 2 (ขายพิพากษา)" },
  { value: 3, icon: "🤝", label: "Phase 3 (ขายทำยอม)" },
  { value: 4, icon: "📥", label: "Phase 4 (โอนเข้าสต็อกรถเก่า)" },
  { value: 6, icon: "💵", label: "Phase 6 (รับชำระเงิน)" },
  { value: 7, icon: "🚘", label: "Phase 7 (รถยึดรอขาย)" },
  { value: 8, icon: "🚙", label: "Phase 8 (ขายรถยึด)" },
];

const STATUS_OPTIONS_AMC = [
  { value: 1, icon: "📦", label: "โอนเข้า Stock(ภายใน)" }, // กล่องสินค้า
  { value: 2, icon: "📑", label: "ขาย/ตั้งลูกหนี้(ภายใน)" }, // การซื้อขาย/ข้อตกลง
  { value: 3, icon: "🏦", label: "รายงานสต็อกเพื่อบัญชี(ภาษี)" }, // หน่วยงานภาษี
  { value: 4, icon: "🧾", label: "รายงานขาย (ขายผ่อน,สด)(ภาษี)" }, // เงินออก/ชำระภาษี
  { value: 5, icon: "💵", label: "รับชำระค่างวด(ภายใน)" }, // ธนบัตรสื่อถึงการรับชำระเงินค่างวด
  { value: 6, icon: "🏦", label: "รับชำระค่างวด(ภาษี)" }, // ธนาคารสื่อถึงการรับชำระเงินที่เข้าสู่ระบบภาษี
  { value: 7, icon: "💵", label: "AMC ขาย HOS(ภายใน)" }, // ธนบัตรสื่อถึงการรับชำระเงินค่างวด
  { value: 8, icon: "🏦", label: "AMC ขาย HOS(ภาษี)" }, // ธนาคารสื่อถึงการรับชำระเงินที่เข้าสู่ระบบภาษี
  { value: 9, icon: "💵", label: "AMC ขายทรัพย์ (ภาษี)" }, // AMC ขายทรัพย์
];

const STATUS_OPTIONS_HOUSING = [
  // รับเงินมัดจำ/ดาวน์/เงินประกัน
  { value: 3, icon: "💰", label: "รับเงินมัดจำ/ดาวน์/เงินประกัน ภายใน" }, // ถุงเงิน = เงินมัดจำที่รับเข้ามา
  { value: 4, icon: "🧾", label: "รับเงินมัดจำ/ดาวน์/เงินประกัน ภาษี" }, // ใบเสร็จ = เอกสารรับเงินที่เกี่ยวกับภาษี

  // ขาย/เช่า (ตั้งลูกหนี้)
  { value: 1, icon: "🤝", label: "ขาย/เช่า(ตั้งลูกหนี้) ภายใน" }, // จับมือ = ตกลงซื้อขาย/เช่า
  { value: 2, icon: "📑", label: "ขาย/เช่า(ตั้งลูกหนี้) ภาษี" }, // เอกสาร = ตั้งลูกหนี้ตามภาษี

  // รับชำระค่างวด/ค่าเช่า
  { value: 5, icon: "💵", label: "รับชำระค่างวด/ค่าเช่า ภายใน" }, // ธนบัตร = รับชำระเงิน
  { value: 6, icon: "🏦", label: "รับชำระค่างวด/ค่าเช่า ภาษี" }, // ธนาคาร = รับชำระเข้าระบบภาษี

  // เช่า: คืนเงินประกัน/ล่วงหน้า
  { value: 7, icon: "↩️", label: "เช่า:คืนเงินประกัน/ล่วงหน้า (ภายใน)" }, // ลูกศรย้อนกลับ = คืนเงิน
  { value: 8, icon: "💸", label: "เช่า:คืนเงินประกัน/ล่วงหน้า (ภาษี)" }, // เงินมีปีก = เงินไหลออก/คืนเงิน

  // เช่า: เลิกเช่า/แปลงซื้อ
  { value: 9, icon: "🔑", label: "เช่า:เลิกเช่า/แปลงซื้อ (ภายใน)" }, // กุญแจ = คืนกุญแจ/เลิกเช่า
  { value: 10, icon: "🏠", label: "เช่า:เลิกเช่า/แปลงซื้อ (ภาษี)" }, // บ้าน = แปลงเช่าเป็นซื้อทรัพย์

  // เช่า: ลูกหนี้อื่น/รับเงิน
  { value: 11, icon: "📒", label: "เช่า: ลูกหนี้อื่น/ริบเงินประกัน (ภายใน)" }, // สมุดบัญชี = บันทึกลูกหนี้อื่น
  { value: 12, icon: "🪙", label: "เช่า: ลูกหนี้อื่น/ริบเงินประกัน (ภาษี)" }, // เหรียญ = รับเงินอื่น ๆ
];

const PROGRAM_OPTIONS = [
  { value: 1, icon: "⚖️", label: "โปรแกรมทนาย" },
  { value: 2, icon: "🏦", label: "โปรแกรม AMC" },
  { value: 3, icon: "🏠", label: "โปรแกรม HOUSING" },
];
const TYPE_OPTIONS = [
  // { value: 1, icon: "📦", label: "Stock" },
  { value: 2, icon: "📑", label: "ภายใน" },
  { value: 3, icon: "💵", label: "ภาษี" },
];

// ประเภท -> สถานะที่เลือกได้ ของแต่ละโปรแกรม (โปรแกรมทนายไม่มีประเภท)
const TYPE_STATUS_MAP = {
  2: { 2: [1, 2, 5, 7], 3: [3, 4, 6, 8, 9] }, // AMC
  3: { 2: [3, 1, 5, 7, 9, 11], 3: [4, 2, 6, 8, 10, 12] }, // HOUSING
};

const getTypeOptions = (program) =>
  TYPE_OPTIONS.filter((o) => TYPE_STATUS_MAP[program]?.[o.value]);

const getStatusOptions = (program, type) => {
  if (program === 1) return STATUS_OPTIONS_LAWYER;
  const options = program === 2 ? STATUS_OPTIONS_AMC : STATUS_OPTIONS_HOUSING;
  const allowed = TYPE_STATUS_MAP[program]?.[type] ?? [];
  return allowed.map((v) => options.find((o) => o.value === v)).filter(Boolean);
};

const formatMoney = (val) =>
  val != null
    ? Number(val).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";

const RECV_NO_STATUS = {
  2: [5, 6], // AMC รับชำระค่างวด
};

// key ของแถวในตาราง = ค่าที่ส่งไป sync แบบเลือก (contract_nos)
const getRowKey = (program, status) => {
  if (program === 1) return (record) => record.contract_no_old;
  // HOUSING: แถวตั้งลูกหนี้ของขายไม่มี recv_no / สัญญาเช่าใบเดียวมีได้หลายแถว
  if (program === 3) return (record) => record.recv_no || record.contract_no;
  if (RECV_NO_STATUS[program]?.includes(status))
    return (record) => record.recv_no;
  return (record) => record.contract_no;
};

// ==================== MAIN COMPONENT ====================
const Main = () => {
  const [convertDateThai, convertDateThaiShort] = DateCustom();

  const [dataArr, setDataArr] = useState([]);
  const [dataTotal, setDataTotal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(1);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [failedRecords, setFailedRecords] = useState([]);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [syncSummary, setSyncSummary] = useState(null); // ผล sync AMC ขาย HOS / HOUSING
  const [kindFilter, setKindFilter] = useState(null); // ตัวกรองคอลัมน์ประเภท (HOUSING)
  const [date, setDate] = useState([
    dayjs().startOf("month"),
    dayjs().endOf("month"),
  ]);

  const typeOptions = getTypeOptions(selectedProgram);
  const statusOptions = getStatusOptions(selectedProgram, selectedType);
  const apiMap =
    selectedProgram === 1
      ? STATUS_API_MAP_LAWYER
      : selectedProgram === 2
        ? STATUS_API_MAP_AMC
        : STATUS_API_MAP_HOUSING;

  const handleProgramChange = useCallback((program) => {
    setSelectedProgram(program);
    const type = getTypeOptions(program)[0]?.value ?? null;
    setSelectedType(type);
    setSelectedStatus(getStatusOptions(program, type)[0]?.value);
    setSelectedRowKeys([]);
    setKindFilter(null);
    setSyncSummary(null);
    setDataTotal(null);
    setDataArr([]);
  }, []);

  const handleTypeChange = useCallback(
    (type) => {
      setSelectedType(type);
      setSelectedStatus(getStatusOptions(selectedProgram, type)[0]?.value);
      setSelectedRowKeys([]);
      setKindFilter(null);
      setSyncSummary(null);
      setDataTotal(null);
      setDataArr([]);
    },
    [selectedProgram],
  );

  const handleStatusChange = useCallback((status) => {
    setSelectedStatus(status);
    setSelectedRowKeys([]);
    setKindFilter(null);
    setSyncSummary(null);
    setDataTotal(null);
    setDataArr([]);
  }, []);

  const hasRowSelected = selectedRowKeys.length > 0;
  const [getApi, postApiAll, postApiSelect] = apiMap[selectedStatus] ?? [];
  const postApi = hasRowSelected ? postApiSelect : postApiAll;
  const selectedOption = statusOptions.find((o) => o.value === selectedStatus);
  const isHos = isToHousing(selectedProgram, selectedStatus); // AMC ขาย HOS 7/8
  const housing = selectedProgram === 3;
  const showBlock = isHos || housing; // แถวที่มี block_code ลงไม่ได้
  const rowKey = getRowKey(selectedProgram, selectedStatus);

  // แถวที่เห็นหลังกรองคอลัมน์ประเภท
  const visibleRows = useMemo(
    () =>
      kindFilter?.length
        ? dataArr.filter((r) => kindFilter.includes(r.kind_group))
        : dataArr,
    [dataArr, kindFilter],
  );

  const loadMain = useCallback(
    async (api) => {
      if (!api) return;
      setLoading(true);
      let payload;
      if (selectedProgram !== 1) {
        payload = {
          from: date?.[0].format("YYYY-MM-DD"),
          to: date?.[1].format("YYYY-MM-DD"),
        };
      }
      console.log(payload);

      console.log("selectedProgram", selectedProgram);

      try {
        const res = await axios.get(api, {
          params: payload,
          headers: HEADERS_NPL,
        });
        const data = res.data;
        if (res.status === 200) {
          setDataTotal(data);
          setDataArr(data?.preview_data ?? []);
          setSelectedRowKeys([]);
          if (data?.preview_data?.length > 0) {
            message.success("โหลดข้อมูลใหม่สำเร็จ");
          } else {
            message.info("ไม่พบข้อมูล");
          }
        }
      } catch (error) {
        if (error.name !== "CanceledError") {
          message.error(
            selectedProgram === 3
              ? httpErrorText(error)
              : error.response?.data?.message ||
                  error.message ||
                  "ไม่สามารถโหลดข้อมูลได้",
          );
          setDataArr([]);
          setDataTotal(null);
        }
      } finally {
        setLoading(false);
      }
    },
    [selectedProgram, date],
  );

  // useEffect(() => {
  //   if (getApi) loadMain(getApi);
  // }, [getApi, loadMain]);

  const handleRefresh = useCallback(() => {
    if (getApi) loadMain(getApi);
  }, [getApi, loadMain]);

  const handlePostGL = useCallback(async () => {
    const [getApiUrl, postAll, postSelect] = apiMap[selectedStatus] ?? [];
    const hasSelection = selectedRowKeys.length > 0;
    const post = hasSelection ? postSelect : postAll;
    if (!post) return;
    if (!hasSelection && (dataArr?.length ?? 0) === 0) return;

    // HOUSING: ส่ง key ของแถวที่เห็นและไม่ติดด่านเสมอ (ไม่เรียก bulk ที่ไม่ดูช่วงวันที่)
    if (housing) {
      const syncKeys = hasSelection
        ? selectedRowKeys
        : visibleRows.filter((r) => !r.block_code).map(rowKey);
      if (syncKeys.length === 0) {
        message.info("ไม่มีรายการที่ลงได้");
        return;
      }
      setLoading(true);
      try {
        let data = null;
        try {
          const res = await axios.post(
            postSelect,
            { contract_nos: syncKeys },
            { headers: HEADERS_NPL },
          );
          data = res.data;
        } catch (err) {
          message.error(httpErrorText(err));
        }
        await loadMain(getApiUrl);
        setSelectedRowKeys([]);
        if (data) {
          const summary = summarizeSync([data], "รายการ");
          setSyncSummary(summary);
          if (summary.failedRecords.length > 0) {
            setFailedRecords(summary.failedRecords);
            setIsFailedModalOpen(true);
          }
        }
      } finally {
        setLoading(false);
      }
      return;
    }

    const hos = isToHousing(selectedProgram, selectedStatus);
    let totalSuccess = 0;
    const allFailedRecords = [];
    const results = []; // response ทุกรอบ (ใช้กับ AMC ขาย HOS)
    console.log("post", post);
    console.log("selectedRowKeys", selectedRowKeys);

    setLoading(true);
    try {
      if (hasSelection) {
        try {
          const res = await axios.post(
            post,
            { contract_nos: selectedRowKeys },
            { headers: HEADERS_NPL },
          );
          const data = res.data;
          results.push(data);

          totalSuccess += data?.success ?? 0;

          if (data?.failed_records?.length > 0) {
            allFailedRecords.push(
              ...data.failed_records.map((r) => ({ ...r, round: 1 })),
            );
          }
        } catch (err) {
          message.error(
            hos
              ? httpErrorText(err)
              : err.response?.data?.message || err.message || "Post GL ล้มเหลว",
          );
        }
      } else {
        const BATCH_SIZE = 50;
        let round = 1;
        let remaining = dataArr?.length ?? 0;

        while (remaining > 0) {
          const currentRound = round;

          try {
            const res = await axios.post(post, {}, { headers: HEADERS_NPL });
            const data = res.data;
            results.push(data);

            totalSuccess += data?.success ?? 0;

            if (data?.failed_records?.length > 0) {
              allFailedRecords.push(
                ...data.failed_records.map((r) => ({
                  ...r,
                  round: currentRound,
                })),
              );
            }
            // HOS: halted / ปฏิเสธทั้งชุด / คิวหมด → หยุดลูปทันที
            if (hos && shouldStopSync(data)) break;
          } catch (err) {
            message.error(
              hos
                ? httpErrorText(err)
                : err.response?.data?.message ||
                    err.message ||
                    `รอบที่ ${currentRound} ล้มเหลว`, // ✅
            );
            if (hos) break;
          }

          remaining = Math.max(0, remaining - BATCH_SIZE);
          round++;
        }
      }

      await loadMain(getApiUrl);
      setSelectedRowKeys([]);

      if (allFailedRecords.length > 0) {
        setFailedRecords(allFailedRecords);
        setIsFailedModalOpen(true);
      }

      if (hos) {
        // เรียกไม่สำเร็จเลย → แสดงแค่ error ที่ขึ้นไปแล้ว
        setSyncSummary(results.length > 0 ? summarizeSync(results) : null);
      } else if (allFailedRecords.length === 0) {
        message.success(`Post GL สำเร็จทั้งหมด ${totalSuccess} รายการ`);
      } else {
        message.warning(
          `สำเร็จ ${totalSuccess} รายการ / ล้มเหลว ${allFailedRecords.length} รายการ`,
        );
      }
    } finally {
      setLoading(false);
    }
  }, [
    apiMap,
    selectedProgram,
    selectedStatus,
    loadMain,
    dataArr,
    selectedRowKeys,
    housing,
    visibleRows,
    rowKey,
  ]);

  const handleGetReport = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(GET_NPL_REPORT, { headers: HEADERS_NPL });
      console.log(res.data);
      message.success("Post GL สำเร็จ");
    } catch (error) {
      message.error(
        error.response?.data?.message || error.message || "Post GL ไม่สำเร็จ",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  const expandedColumns = [
    {
      title: "รหัสบัญชี",
      dataIndex: "account_code",
      key: "account_code",
      width: 110,
      render: (v) => <Tag color="blue">{v}</Tag>,
    },
    {
      title: "คำอธิบาย",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "DR/CR",
      dataIndex: "drcr",
      key: "drcr",
      width: 80,
      align: "center",
      render: (v) => <Tag color={v === "DR" ? "red" : "green"}>{v}</Tag>,
    },
    {
      title: "จำนวนเงิน",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: 140,
      render: (v) => (
        <Text strong style={{ fontVariantNumeric: "tabular-nums" }}>
          {formatMoney(v)}
        </Text>
      ),
    },
  ];

  const columnsHousing = [
    {
      title: "เลขสัญญา",
      dataIndex: "contract_no",
      key: "contract_no",
      // width: "12%",
      render: (v) => (
        <Text copyable={v} strong>
          {v}
        </Text>
      ),
    },

    {
      title: "ชื่อลูกหนี้",
      dataIndex: "customer_name",
      key: "customer_name",
      // width: "12%",
      render: (v) => <Tag color="purple">{v}</Tag>,
    },

    {
      title: "สาขา",
      dataIndex: "locat",
      key: "locat",
      // width: "12%",
      align: "center",
      render: (v) => <Tag>📍{v}</Tag>,
    },

    {
      title: "ประเภท",
      dataIndex: "kind",
      key: "kind",
      filters: [
        { text: "ขาย", value: "ขาย" },
        { text: "เช่า", value: "เช่า" },
      ],
      filteredValue: kindFilter,
      onFilter: (value, record) => record.kind_group === value,
      render: (v, record) =>
        v ? (
          <Tag color={record.kind_group === "เช่า" ? "gold" : "blue"}>{v}</Tag>
        ) : (
          "-"
        ),
    },

    {
      title: "เลขบิล/วันที่บิล",
      dataIndex: "bill_date",
      key: "bill_date",
      // width: "12%",
      align: "center",
      render: (_, record) => (
        <>
          <Text
            copyable={record.recv_no}
            strong
            style={{ fontVariantNumeric: "tabular-nums" }}
          >
            {record.recv_no}
          </Text>
          <br />
          <Text strong style={{ fontVariantNumeric: "tabular-nums" }}>
            {convertDateThaiShort(record.bill_date)}
          </Text>
        </>
      ),
    },

    {
      title: "จำนวนเงิน",
      dataIndex: "net_pay",
      key: "net_pay",
      // width: "14%",
      align: "right",
      // แถวตั้งลูกหนี้ของขายไม่มี net_pay
      render: (_, record) => (
        <Text strong style={{ fontVariantNumeric: "tabular-nums" }}>
          {formatMoney(record.net_pay ?? record.amount)}
        </Text>
      ),
    },

    {
      title: "งบดุล",
      dataIndex: "is_balance_matched",
      key: "is_balance_matched",
      // width: "12%",
      align: "center",
      render: (v) =>
        v ? (
          <CheckCircleOutlined style={{ color: THEME.success, fontSize: 18 }} />
        ) : (
          <CloseCircleOutlined style={{ color: THEME.danger, fontSize: 18 }} />
        ),
    },
  ];

  const columnsAmc = [
    {
      title: "เลขสัญญา",
      dataIndex: "contract_no",
      key: "contract_no",
      // width: "12%",
      render: (v) => (
        <Text copyable={v} strong>
          {v}
        </Text>
      ),
    },

    {
      title: "รหัสลูกหนี้",
      dataIndex: "borr_code",
      key: "borr_code",
      // width: "12%",
      render: (v) => <Tag color="purple">{v}</Tag>,
    },

    // {
    //   title: "Batch",
    //   dataIndex: "batch_id",
    //   key: "batch_id",
    //   width: "14%",
    // },

    // {
    //   title: "Tranche",
    //   dataIndex: "tranche",
    //   key: "tranche",
    //   width: "14%",
    // },

    {
      title: "สาขา",
      dataIndex: "locat",
      key: "locat",
      // width: "12%",
      align: "center",
      render: (v) => <Tag>📍{v}</Tag>,
    },
    {
      title: "เลขบิล/วันที่บิล",
      dataIndex: "bill_date",
      key: "bill_date",
      // width: "12%",
      align: "center",
      render: (_, record) => (
        <>
          {record.recv_no && (
            <>
              <Text
                copyable={record.recv_no}
                strong
                style={{ fontVariantNumeric: "tabular-nums" }}
              >
                {record.recv_no}
              </Text>
              <br />
            </>
          )}

          <Text strong style={{ fontVariantNumeric: "tabular-nums" }}>
            {convertDateThaiShort(record.bill_date)}
          </Text>
        </>
      ),
    },

    {
      title: "จำนวนเงิน",
      dataIndex: "net_pay",
      key: "net_pay",
      // width: "14%",
      align: "right",
      render: (v, record) => (
        <Text strong style={{ fontVariantNumeric: "tabular-nums" }}>
          {formatMoney(v ?? record.amount)}
        </Text>
      ),
    },

    {
      title: "งบดุล",
      dataIndex: "is_balance_matched",
      key: "is_balance_matched",
      // width: "12%",
      align: "center",
      render: (v) =>
        v ? (
          <CheckCircleOutlined style={{ color: THEME.success, fontSize: 18 }} />
        ) : (
          <CloseCircleOutlined style={{ color: THEME.danger, fontSize: 18 }} />
        ),
    },
  ];

  // AMC ขาย HOS / HOUSING: แถวที่ลงไม่ได้ แสดงเหตุผลใน expand
  const renderBlocked = (record) => (
    <Alert
      type="error"
      showIcon={false}
      style={{ margin: "8px 0", borderRadius: 8 }}
      message={
        <Space wrap>
          <Tag color="red" style={{ fontWeight: 700 }}>
            ⛔ {blockLabel(record.block_code)}
          </Tag>
          <Text strong>
            {housing ? `สัญญา ${record.contract_no}` : `โฉนด ${record.deed_no}`}
          </Text>
        </Space>
      }
      description={
        <>
          {blockTell(record.block_code) && (
            <div>{blockTell(record.block_code)}</div>
          )}
          <Text type="danger" style={{ fontSize: 12 }}>
            {record.blocked}
          </Text>
        </>
      }
    />
  );

  const columnsLawyer = [
    {
      title: "สัญญาเดิม",
      dataIndex: "contract_no_old",
      key: "contract_no_old",
      width: "10%",
      render: (v) => (
        <Text copyable={v} strong>
          {v}
        </Text>
      ),
    },
    {
      title: "วันที่",
      dataIndex: "tmbildt",
      key: "tmbildt",
      width: "10%",
      render: (v) => <>{convertDateThaiShort(v)}</>,
    },
    {
      title: "สัญญาใหม่",
      dataIndex: "contract_no_new",
      key: "contract_no_new",
      width: "10%",
      render: (v) => <Tag color="purple">{v}</Tag>,
    },
    {
      title: "ชื่อลูกค้า",
      dataIndex: "customer_name",
      key: "customer_name",
      width: "30%",
    },
    selectedStatus === 1 && {
      title: "กลุ่มสินค้า",
      dataIndex: "gcode",
      key: "gcode",
      render: (v) => <Tag color="purple">{v}</Tag>,
    },
    {
      title: "สาขา",
      dataIndex: "locat",
      key: "locat",
      width: "10%",
      align: "center",
      render: (v) => <Tag>📍{v}</Tag>,
    },
    {
      title: "Phase",
      dataIndex: "phase",
      key: "phase",
      width: "10%",
      align: "center",
      render: (v) => <Tag color="blue">{v}</Tag>,
    },
    {
      title: "สัญญา",
      dataIndex: "schema_name",
      key: "schema_name",
      width: "10%",
      align: "center",
      render: (v) => {
        const item = OPTIONS_TYPE.find((item) => item.value === v);
        return <Tag color="orange">{item?.label || "-"}</Tag>;
      },
    },
    {
      title: "ยอด Debit",
      dataIndex: "total_debit",
      key: "total_debit",
      align: "right",
      width: "10%",
      render: (v) => (
        <Text
          style={{ color: THEME.danger, fontVariantNumeric: "tabular-nums" }}
        >
          {formatMoney(v)}
        </Text>
      ),
    },
    {
      title: "ยอด Credit",
      dataIndex: "total_credit",
      key: "total_credit",
      align: "right",
      width: "10%",
      render: (v) => (
        <Text
          style={{ color: THEME.success, fontVariantNumeric: "tabular-nums" }}
        >
          {formatMoney(v)}
        </Text>
      ),
    },
    {
      title: "งบดุล",
      dataIndex: "is_balance_matched",
      key: "is_balance_matched",
      width: "10%",
      align: "center",
      render: (v) =>
        v ? (
          <CheckCircleOutlined style={{ color: THEME.success, fontSize: 18 }} />
        ) : (
          <CloseCircleOutlined style={{ color: THEME.danger, fontSize: 18 }} />
        ),
    },
  ].filter(Boolean);

  // ==================== SUMMARY CARDS ====================
  const renderSummaryCards = () => {
    // กรองอยู่ → นับจากแถวที่เห็น ไม่กรอง → ใช้ยอดจาก API
    const filtered = kindFilter?.length > 0;
    const sumEntries = (drcr) =>
      visibleRows.reduce(
        (s, r) =>
          s +
          [...(r.internal_entries ?? []), ...(r.tax_entries ?? [])]
            .filter((e) => e.drcr === drcr)
            .reduce((t, e) => t + Number(e.amount || 0), 0),
        0,
      );
    const totalDebit = filtered ? sumEntries("DR") : dataTotal?.total_debit_all;
    const totalCredit = filtered
      ? sumEntries("CR")
      : dataTotal?.total_credit_all;

    const cards = [
      {
        label: "สัญญารอ Post",
        value: filtered
          ? visibleRows.length
          : (dataTotal?.total_transactions ?? "-"),
        sub: "รายการ",
        icon: "📋",
        bg: "var(--color-background-danger)",
        border: "var(--color-border-danger)",
        textColor: "var(--color-text-danger)",
      },
      {
        label: "ยอด Debit รวม",
        value: totalDebit != null ? formatMoney(totalDebit) : "-",
        sub: "บาท",
        icon: "📤",
        bg: "var(--color-background-warning)",
        border: "var(--color-border-warning)",
        textColor: "var(--color-text-warning)",
      },
      {
        label: "ยอด Credit รวม",
        value: totalCredit != null ? formatMoney(totalCredit) : "-",
        sub: "บาท",
        icon: "📥",
        bg: "var(--color-background-info)",
        border: "var(--color-border-info)",
        textColor: "var(--color-text-info)",
      },
    ];

    return (
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {cards.map(({ label, value, sub, icon, bg, border, textColor }) => (
          <Col xs={24} sm={8} key={label}>
            <div
              style={{
                background: bg,
                border: `1px solid ${border}`,
                borderRadius: 12,
                padding: "16px 20px",
                display: "flex",
                alignItems: "center",
                gap: 16,
                height: "100%",
              }}
            >
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 22,
                  flexShrink: 0,
                }}
              >
                {icon}
              </div>
              <div style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 13,
                    color: textColor,
                    display: "block",
                    marginBottom: 4,
                    opacity: 0.85,
                  }}
                >
                  {label}
                </Text>
                <div
                  style={{ display: "flex", alignItems: "baseline", gap: 6 }}
                >
                  <span
                    style={{
                      fontSize: 22,
                      fontWeight: 700,
                      color: textColor,
                      lineHeight: 1,
                      fontVariantNumeric: "tabular-nums",
                    }}
                  >
                    {value}
                  </span>
                  <Text
                    style={{ fontSize: 12, color: textColor, opacity: 0.7 }}
                  >
                    {sub}
                  </Text>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    );
  };

  const failedColumns = [
    {
      title: "ลำดับ",
      width: 80,
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "รอบที่",
      dataIndex: "round",
      key: "round",
      width: 80,
      align: "center",
      render: (v) => <Tag color="blue">รอบ {v}</Tag>,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "contract_no",
      key: "contract_no",
      width: 150,
      render: (v) => <Text strong>{v}</Text>,
    },
    {
      title: "สาเหตุ",
      dataIndex: "error",
      key: "error",
      render: (v) => (
        <Text type="danger" style={{ fontSize: 12 }}>
          {v}
        </Text>
      ),
    },
  ];

  // ==================== RENDER ====================
  return (
    <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 12,
          border: "1px solid #ffcb05",
          background: "#fffdf0",
          padding: "12px 16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 12px",
              borderRadius: 8,
              background: "#fff3cc",
              border: "1px solid #ffcb05",
              whiteSpace: "nowrap",
            }}
          >
            <span style={{ fontSize: 14, color: "#efa420" }}>🔍</span>
            <span style={{ fontSize: 13, fontWeight: 500, color: "#efa420" }}>
              เลือกโปรแกรม
            </span>
          </div>

          <Select
            size="large"
            placeholder="เลือก โปรแกรม"
            value={selectedProgram}
            onChange={handleProgramChange}
            style={{ minWidth: 220 }}
            options={PROGRAM_OPTIONS.map(({ value, icon, label }) => ({
              value,
              label: `${icon} ${label}`,
            }))}
          />

          {selectedProgram !== 1 && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "6px 12px",
                  borderRadius: 8,
                  background: "#fff3cc",
                  border: "1px solid #ffcb05",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ fontSize: 14, color: "#efa420" }}>🔍</span>
                <span
                  style={{ fontSize: 13, fontWeight: 500, color: "#efa420" }}
                >
                  เลือกประเภท
                </span>
              </div>

              <Select
                size="large"
                placeholder="เลือก ประเภท"
                value={selectedType}
                onChange={handleTypeChange}
                style={{ minWidth: 160 }}
                options={typeOptions.map(({ value, icon, label }) => ({
                  value,
                  label: `${icon} ${label}`,
                }))}
              />
            </>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 12px",
              borderRadius: 8,
              background: "#fff3cc",
              border: "1px solid #ffcb05",
              whiteSpace: "nowrap",
            }}
          >
            <span style={{ fontSize: 14, color: "#efa420" }}>🔍</span>
            <span style={{ fontSize: 13, fontWeight: 500, color: "#efa420" }}>
              เลือกสถานะ
            </span>
          </div>

          <Select
            size="large"
            placeholder="เลือก Phase"
            value={selectedStatus}
            onChange={handleStatusChange}
            style={{ minWidth: 220 }}
            popupMatchSelectWidth={false}
            options={statusOptions.map(({ value, icon, label }) => ({
              value,
              label: `${icon} ${label}`,
            }))}
          />
          {selectedProgram !== 1 && (
            <ThaiRangePicker
              size="large"
              value={date}
              onChange={setDate}
              allowClear={true}
            />
          )}
          <Button
            variant="outlined"
            color="orange"
            icon={<ReloadOutlined />}
            onClick={handleRefresh}
            loading={loading}
          >
            โหลดข้อมูล
          </Button>

          {/* <Button
            type="primary"
            loading={loading}
            style={{
              borderRadius: 8,
              boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
              fontWeight: "bold",
              background: "linear-gradient(135deg, #667eea, blue)",
              border: "none",
            }}
            icon={<SendOutlined />}
            onClick={handleGetReport}
            disabled={dataArr?.length === 0}
          >
            พิมพ์รายงาน
          </Button> */}

          {selectedOption && (
            <Tag
              style={{
                marginLeft: "auto",
                fontSize: 13,
                borderRadius: 20,
                padding: "3px 12px",
                background: "#fff3cc",
                border: "1px solid #ffcb05",
                color: "#efa420",
                fontWeight: 500,
              }}
            >
              {selectedOption.icon} {selectedOption.label}
            </Tag>
          )}
        </div>
        <div style={{ marginTop: 10 }}>
          <Button
            variant="outlined"
            color="blue"
            loading={loading}
            // style={{
            //   borderRadius: 8,
            //   boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            //   fontWeight: "bold",
            //   background: "linear-gradient(135deg, #667eea, blue)",
            //   border: "none",
            // }}
            icon={<SendOutlined />}
            onClick={handlePostGL}
            disabled={
              !postApi ||
              (hasRowSelected ? false : (dataArr?.length ?? 0) === 0)
            }
          >
            Post GL
          </Button>
          {hasRowSelected && (
            <Tag
              style={{ marginLeft: 10 }}
              color="blue"
              closable
              onClose={(e) => {
                e.preventDefault();
                setSelectedRowKeys([]);
              }}
            >
              เลือก {selectedRowKeys.length} {housing ? "รายการ" : "สัญญา"}
            </Tag>
          )}
        </div>
      </Card>
      {/* Summary Cards */}
      {renderSummaryCards()}
      {/* ผล sync AMC ขาย HOS */}
      {showBlock && syncSummary && (
        <Modal
          open
          centered
          title={housing ? "ผลการลงบัญชี HOUSING" : "ผลการส่งข้อมูล HOS"}
          closable={!syncSummary.halted}
          maskClosable={!syncSummary.halted}
          onCancel={() => setSyncSummary(null)}
          width={800}
          footer={
            <Button type="primary" onClick={() => setSyncSummary(null)}>
              ตกลง
            </Button>
          }
        >
          <Alert
            type={TONE_ALERT_TYPE[syncSummary.tone]}
            showIcon
            style={{ borderRadius: 8 }}
            message={<Text strong>{syncSummary.title}</Text>}
            description={
              syncSummary.lines.length > 0 &&
              syncSummary.lines
                .filter(Boolean)
                .map((l, i) => <div key={i}>{l}</div>)
            }
          />
        </Modal>
      )}
      {/* Table */}
      <Table
        size="small"
        columns={
          selectedProgram === 1
            ? columnsLawyer
            : selectedProgram === 2
              ? columnsAmc
              : columnsHousing
        }
        dataSource={dataArr}
        onRow={(record) =>
          showBlock && record.block_code
            ? { style: { background: "#fde7e5" } }
            : {}
        }
        rowKey={rowKey}
        onChange={(_, filters, __, extra) => {
          // เปลี่ยนตัวกรอง → ล้างแถวที่ติ๊ก กันลงแถวที่ถูกกรองซ่อน (ไม่ทำตอนเปลี่ยนหน้า)
          if (extra?.action !== "filter") return;
          setKindFilter(filters.kind ?? null);
          setSelectedRowKeys([]);
        }}
        // rowKey={(record) =>
        //         selectedProgram === 2 || selectedProgram === 3
        //           ? (selectedStatus >= 5 && selectedProgram === 2) ||
        //             (selectedProgram === 3 && selectedStatus > 2)
        //             ? record.recv_no
        //             : record.contract_no
        //           : record.contract_no_old
        //       }

        scroll={{ x: 900 }}
        locale={{ emptyText: <Empty description="ไม่มีข้อมูล" /> }}
        rowSelection={
          selectedProgram === 1 && selectedStatus === 1
            ? undefined
            : {
                selectedRowKeys,
                onChange: setSelectedRowKeys,
                getCheckboxProps: (record) => ({
                  disabled: showBlock && !!record.block_code,
                }),
              }
        }
        expandable={{
          expandedRowRender: (record) => {
            const entries =
              selectedProgram === 2 || selectedProgram === 3
                ? [
                    ...(record.internal_entries ?? []),
                    ...(record.tax_entries ?? []),
                  ]
                : (record.entries ?? []);
            return (
              <>
                {showBlock && record.block_code && renderBlocked(record)}
                {entries.length > 0 && (
                  <Table
                    size="small"
                    columns={expandedColumns}
                    dataSource={entries}
                    rowKey={(e) =>
                      `${e.reference_id ?? ""}-${e.account_code}-${e.drcr}-${e.amount}`
                    }
                    pagination={false}
                    style={{ margin: "8px 0" }}
                  />
                )}
              </>
            );
          },
          // แถวที่ติด block ต้องกางได้เสมอ (tax_entries/internal_entries เป็น null)
          rowExpandable: (record) =>
            (showBlock && !!record.block_code) ||
            (selectedProgram === 2 || selectedProgram === 3
              ? (record.internal_entries?.length ?? 0) > 0 ||
                (record.tax_entries?.length ?? 0) > 0
              : record.entries?.length > 0),
        }}
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          showTotal: (total) => `ทั้งหมด ${total} รายการ`,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        footer={() => (
          <Text type="secondary">
            จำนวนสัญญาทั้งหมด {visibleRows?.length ?? 0} รายการ
          </Text>
        )}
      />
      {isFailedModalOpen && (
        <Modal
          title={
            <Space>
              <CloseCircleOutlined style={{ color: THEME.danger }} />
              <Text strong>
                รายการที่ล้มเหลว ({failedRecords.length} รายการ)
              </Text>
            </Space>
          }
          open={isFailedModalOpen}
          onCancel={() => setIsFailedModalOpen(false)}
          footer={
            <Button type="primary" onClick={() => setIsFailedModalOpen(false)}>
              ปิด
            </Button>
          }
          width={800}
        >
          <Table
            size="small"
            columns={failedColumns}
            dataSource={failedRecords}
            rowKey={(r) => `${r.round}-${r.contract_no}`}
            pagination={{ pageSize: 10 }}
          />
        </Modal>
      )}
    </Spin>
  );
};

const ContractDetail = MotionHoc(Main);
export default ContractDetail;
